import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  fontWeights,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container } from './ui';

const StyledTable = styled.section`
  ${sectionMargins('20px', '40px')};
`;

const StyledContainer = styled(Container)`
  ${({ isBlogDetail }) => {
    if (isBlogDetail) {
      return css`
        padding-left: 0;
        padding-right: 0;
      `;
    }
  }};
`;

const StyledContent = styled.div`
  ${maxBreakpointQuery.mlarge`
    overflow-x: scroll;
  `}

  table,
  thead,
  tbody,
  th,
  td,
  tr {
    border: 0;
  }

  thead {
    font-weight: ${fontWeights.bold};
  }

  td {
    padding: 16px 12px;
    color: ${brandColours.secondary};
    ${fontSize(14)};
    line-height: 1.4;
    border: 1px solid ${brandColours.secondary};
    box-sizing: border-box;

    ${minBreakpointQuery.small`
      ${fontSize(15)};
    `}

    ${minBreakpointQuery.large`
      ${fontSize(16)};
    `}

    p {
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    ${({ firstColumnOneLine }) => {
      if (firstColumnOneLine) {
        return css`
          &:first-child {
            white-space: nowrap;
          }
        `;
      }
    }}
  }
`;

const Table = ({ table, firstColumnOneLine, isBlogDetail }) => (
  <StyledTable>
    <StyledContainer
      narrower={isBlogDetail}
      narrow={!isBlogDetail}
      isBlogDetail={isBlogDetail}
    >
      <StyledContent
        dangerouslySetInnerHTML={{ __html: table }}
        firstColumnOneLine={firstColumnOneLine}
      />
    </StyledContainer>
  </StyledTable>
);

export default Table;
